import React, { useEffect, useState, useContext } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import api, { API_URL, APPNAME, AuthContext } from "./util/api";

export default function Navbar() {
  const { token, User, logout, Doctor } = useContext(AuthContext);
  const navigate = useNavigate();

  const [menuOpen, setMenuOpen] = useState(false);
  const [dashboardLink, setDashboardLink] = useState("/dashboard");
  const [profileLink, setProfileLink] = useState("");
  const [messageLink, setMessageLink] = useState("");
  const [noticount, setNotification] = useState(0);
  const [messageCount, setMessageCount] = useState(0);

  const isAuthenticated = Boolean(token && User);

  const fetchNotificationCount = async () => {
    const res = await api.get(`${API_URL}/notification_count`);
    if (res.status === 200 && res.data.status === "successful") {
      setNotification(res.data.notification_count);
      setMessageCount(res.data.chat_count);
    }
  };

  useEffect(() => {
    if (!User) return;
    fetchNotificationCount();
    const t = setInterval(fetchNotificationCount, 600000);
    return () => clearInterval(t);
  }, [User]);

  useEffect(() => {
    if (!User) return;

    if (User.role === "doctor") {
      setDashboardLink("/doctor-dashboard");
      setProfileLink("/doctor-profile-reg");
      setMessageLink("/doctor-ongoing-appointments");
    }

    if (User.role === "patient") {
      setDashboardLink("/patient-dashboard");
      setProfileLink("/patient-reg");
      setMessageLink("/patient-ongoing-appointments");
    }

    if (User.role === "none") {
      setDashboardLink("/select-role");
      setProfileLink("/select-role");
    }
  }, [User]);

  const logoutf = () => {
    logout();
   
  };

  return (
    <>
      <header className="pro-header">
        <div className="pro-container">

          {/* Logo */}
          {isAuthenticated && (
            <Link to="/" className="brand-logo">
              {APPNAME}
            </Link>
          )}

          {/* Desktop Nav */}
          <nav className="desktop-nav">
            <NavLink to="/">Home</NavLink>
            <NavLink to="/doctors">Doctors</NavLink>
            <NavLink to="/about-us">About</NavLink>

            {isAuthenticated && <NavLink to={dashboardLink}>Dashboard</NavLink>}
            {isAuthenticated && <NavLink to="/payment_details">Payment Info</NavLink>}
          </nav>

          {/* Right Section */}
          <div className="right-section">

            {isAuthenticated && (
              <>
                <NavLink to={messageLink} className="icon-wrapper">
                  💬
                  {messageCount > 0 && <span>{messageCount}</span>}
                </NavLink>

                <NavLink to="/notifications" className="icon-wrapper">
                  🔔
                  {noticount > 0 && <span>{noticount}</span>}
                </NavLink>
              </>
            )}

            {/* Account */}
            <div className="account-area">

                {isAuthenticated && (
              <button
                className="menu-btn"
                onClick={() => setMenuOpen(!menuOpen)}
              >
                ☰
              </button>

                )}

              {menuOpen && isAuthenticated && (
                <div className="dropdown-box">
                  {User?.role === "doctor" && (
                    <Link to={`/doctor-profile/${Doctor?.id}`}>
                      View Profile
                    </Link>
                  )}
                  <Link to={profileLink}>Edit Profile</Link>
                  <button onClick={logoutf} className="logout-btn">
                    Logout
                  </button>
                </div>
              )}
            </div>

            {!isAuthenticated && (
              <div className="auth-area">
                <NavLink to="/login">Login</NavLink>
                <NavLink to="/register" className="register-btn">
                  Register
                </NavLink>
              </div>
            )}
          </div>
        </div>

        {/* Mobile Menu */}
        {menuOpen && (
          <div className="mobile-nav">
            <NavLink to="/">Home</NavLink>
            <NavLink to="/doctors">Doctors</NavLink>
            <NavLink to="/about-us">About</NavLink>
            {isAuthenticated && <NavLink to={dashboardLink}>Dashboard</NavLink>}
            {isAuthenticated && <NavLink to="/payment_details">Payment Info</NavLink>}
          </div>
        )}
      </header>

      <style>{`
        .pro-header {
          position: sticky;
          top: 0;
          backdrop-filter: blur(12px);
          background: linear-gradient(135deg, #ffffffdd, #f0f4ffcc);
          box-shadow: 0 4px 20px rgba(0,0,0,0.05);
          z-index: 999;
        }

        .pro-container {
          max-width: 1200px;
          margin: auto;
          padding: 16px 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .brand-logo {
          font-size: 22px;
          font-weight: 700;
          background: linear-gradient(45deg,#2563eb,#7c3aed);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          text-decoration: none;
        }

        .desktop-nav {
          display: flex;
          gap: 28px;
        }

        .desktop-nav a {
          text-decoration: none;
          font-weight: 500;
          color: #374151;
          position: relative;
          transition: 0.3s;
        }

        .desktop-nav a:hover {
          color: #2563eb;
        }

        .desktop-nav a.active::after {
          content: "";
          position: absolute;
          bottom: -6px;
          left: 0;
          width: 100%;
          height: 3px;
          background: linear-gradient(90deg,#2563eb,#7c3aed);
          border-radius: 3px;
        }

        .right-section {
          display: flex;
          align-items: center;
          gap: 18px;
        }

        .icon-wrapper {
          position: relative;
          font-size: 18px;
          text-decoration: none;
          transition: transform 0.2s ease;
        }

        .icon-wrapper:hover {
          transform: scale(1.15);
        }

        .icon-wrapper span {
          position: absolute;
          top: -6px;
          right: -10px;
          background: #ef4444;
          color: #fff;
          font-size: 10px;
          padding: 3px 6px;
          border-radius: 20px;
        }

        .menu-btn {
          border: none;
          background: #0156ffff;
          padding: 6px 10px;
          border-radius: 6px;
          cursor: pointer;
          font-size: 18px;
        }

        .dropdown-box {
          position: absolute;
          right: 20px;
          top: 70px;
          background: #fff;
          border-radius: 12px;
          box-shadow: 0 15px 40px rgba(0,0,0,0.08);
          overflow: hidden;
          min-width: 180px;
        }

        .dropdown-box a,
        .dropdown-box button {
          display: block;
          width: 100%;
          padding: 12px 16px;
          border: none;
          background: none;
          text-align: left;
          cursor: pointer;
          text-decoration: none;
          color: #374151;
          transition: 0.3s;
        }

        .dropdown-box a:hover,
        .dropdown-box button:hover {
          background: #f3f4f6;
        }

        .logout-btn {
          color: #ef4444 !important;
          fontweight:bolder
        }

        .auth-area a {
          margin-left: 12px;
          text-decoration: none;
        }

        .register-btn {
          background: linear-gradient(45deg,#2563eb,#7c3aed);
          color: #fff;
          padding: 6px 14px;
          border-radius: 20px;
        }

        .mobile-nav {
          display: none;
          flex-direction: column;
          gap: 14px;
          padding: 16px 20px;
          background: #f9fafb;
        }

        @media (max-width: 768px) {
          .desktop-nav {
            display: none;
          }

          .mobile-nav {
            display: flex;
          }
        }
      `}</style>
    </>
  );
}